/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caseslistheading2Inputs */

const en_caseslistheading2 = /** @type {(inputs: Caseslistheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your cases`)
};

const pt_caseslistheading2 = /** @type {(inputs: Caseslistheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os seus casos`)
};

/**
* | output |
* | --- |
* | "Your cases" |
*
* @param {Caseslistheading2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const caseslistheading2 = /** @type {((inputs?: Caseslistheading2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caseslistheading2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_caseslistheading2(inputs)
	return pt_caseslistheading2(inputs)
});
export { caseslistheading2 as "casesListHeading" }